import { Card } from "../components/Card";
import { ReactComponent as WebBrowser } from "../icons/browser-website.svg";
// import { ReactComponent as Pointer } from "../icons/pointer2.svg";

export default function Lodging() {
  return (
    <Card id="lodging" className="lodging" bgc="fill" title="Conner Family Reunion 2025 Lodging">
      <p>
        We have made arrangements for the reunion for special pricing at The Hampton Inn West
        in West Plains.  It includes free internet and a continental breakfast. To view more 
        amenities and the room layouts, please follow the website link below.
      </p>

      <div className="hotel">
        <div className="heading">
          <div>The Hampton Inn West – West Plains</div>
          <div className="url">
            <a href="https://www.hilton.com/en/hotels/tbnwphx-hampton-west-plains/" target="connertab">Go to Website {<WebBrowser style={{ margin: 0, padding: 0, width: "2.5rem"}} />}</a>
          </div>
        </div>

        <div className="hotelcontainer">
        
          <div className="room">
            <span className="roomtype">King / King + sofa / Double Queen</span>
            <span className="roomprice">$115 + tax</span>
          </div>
          <div>
            <p>
              To make reservations, call <a href="tel:4172550442">417-255-0442</a> and be sure to indicate you are with the “Conner Reunion”.
            </p>
          </div>
        </div>
      </div>

    </Card>
  );


}